import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgOtherTransaction = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 135,
	height: 135,
	viewBox: "0 0 135 135",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M68.0259 20.6406V29.8613M55.0426 35.7888L51.1058 31.8371M48.6989 48.6064H38.2009M86.7542 48.6064H97.2522M80.4106 35.7888L84.3473 31.8371",
			stroke: "#F385FF",
			strokeWidth: 3,
			strokeLinecap: "square"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.6344 114.637L83.8113 77.0606H51.4575L67.6344 114.637Z",
			fill: "#63688B",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.9407 114.637L89.8376 77.0606H83.1784L66.9407 114.637Z",
			fill: "#63688B",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.3306 114.637L45.4337 77.0606H52.0929L68.3306 114.637Z",
			fill: "#63688B",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M67.6336 39.9258L51.4567 77.5019H83.8105L67.6336 39.9258Z",
			fill: "#63688B",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M68.3286 39.9258L45.4317 77.5019H52.0909L68.3286 39.9258Z",
			fill: "#63688B",
			stroke: "white",
			strokeWidth: 2
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M66.9375 39.9258L89.8344 77.5019H83.1752L66.9375 39.9258Z",
			fill: "#63688B",
			stroke: "white",
			strokeWidth: 2
		})
	]
});
export default SvgOtherTransaction;
